<template>
  <b-modal
    id="modalProcessNotFound"
    centered
    title="Comando sale not found"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <b-tabs v-model="tabIndex" pills justified>
      <b-tab title="Pagar.me" active>
        <div class="mb-3">
          <label for="transactionID" class="form-label">Transaction ID</label>
          <b-form-input
            id="transactionID"
            v-model="formPagarme.transactionID"
            placeholder="Digite o Transaction ID"
            :state="!errorsForm.transactionID"
          />
          <b-form-invalid-feedback v-if="errorsForm.transactionID">
            {{ errorsForm.transactionID }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="clientID" class="form-label">Client ID</label>
          <b-form-input
            id="clientID"
            v-model="formPagarme.clientID"
            placeholder="Digite o Client ID"
            :state="!errorsForm.clientID"
          />
          <b-form-invalid-feedback v-if="errorsForm.clientID">
            {{ errorsForm.clientID }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="offerID" class="form-label">Offer ID</label>
          <b-form-input
            id="offerID"
            v-model="formPagarme.offerID"
            placeholder="Digite o Offer ID"
            :state="!errorsForm.offerID"
          />
          <b-form-invalid-feedback v-if="errorsForm.offerID">
            {{ errorsForm.offerID }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="leadID" class="form-label">Lead ID</label>
          <b-form-input
            id="leadID"
            v-model="formPagarme.leadID"
            placeholder="Digite o Lead ID"
            :state="!errorsForm.leadID"
          />
          <b-form-invalid-feedback v-if="errorsForm.leadID">
            {{ errorsForm.leadID }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="subscriptionID" class="form-label">Subscription ID</label>
          <b-form-input
            id="subscriptionID"
            v-model="formPagarme.subscriptionID"
            placeholder="Digite o Subscription ID"
            :state="!errorsForm.subscriptionID"
          />
          <b-form-invalid-feedback v-if="errorsForm.subscriptionID">
            {{ errorsForm.subscriptionID }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>

      <b-tab title="IUGU">
        <div class="mb-3">
          <label for="transactionIDIugu" class="form-label">Transaction ID</label>
          <b-form-input
            id="transactionID_Iugu"
            v-model="formIugu.transactionID"
            placeholder="Digite o Transaction ID"
            :state="!errorsForm.transactionID"
          />
          <b-form-invalid-feedback v-if="errorsForm.transactionID">
            {{ errorsForm.transactionID }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="leadID_Iugu" class="form-label">Lead ID</label>
          <b-form-input
            id="leadID_Iugu"
            v-model="formIugu.leadID"
            placeholder="Digite o Lead ID"
            :state="!errorsForm.leadID"
          />
          <b-form-invalid-feedback v-if="errorsForm.leadID">
            {{ errorsForm.leadID }}
          </b-form-invalid-feedback>
        </div>

        <div class="mb-3">
          <label for="subscriptionID_Iugu" class="form-label">Subscription ID</label>
          <b-form-input
            id="subscriptionID_Iugu"
            v-model="formIugu.subscriptionID"
            placeholder="Digite o Subscription ID"
            :state="!errorsForm.subscriptionID"
          />
          <b-form-invalid-feedback v-if="errorsForm.subscriptionID">
            {{ errorsForm.subscriptionID }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Concluir</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import OperationsService from '@services/resources/OperationsService';

const service = OperationsService.build();

export default {
  name: 'modalProcessNotFound',
  data() {
    return {
      tabIndex: 0,
      errorsForm: {},
      formPagarme: {
        transactionID: '',
        clientID: '',
        offerID: '',
        leadID: '',
        subscriptionID: '',
      },
      formIugu: {
        transactionID: '',
        leadID: '',
        subscriptionID: '',
      },
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      const form = this.tabIndex === 0 ? this.formPagarme : this.formIugu;
      for (const [key, value] of Object.entries(form)) {
        if (!value.trim()) {
          this.errorsForm[key] = `O campo ${key} é obrigatório.`;
        }
      }

      return Object.keys(this.errorsForm).length === 0;
    },
    async submitData() {
      if (!this.validateFields()) return;

      try {
        const isPagarme = this.tabIndex === 0;
        const payload = isPagarme ? this.formPagarme : this.formIugu;

        if (isPagarme) {
          await service.post('process-not-found-pagarme', payload);
        } else {
          await service.post('process-not-found-iugu', payload);
        }

        this.$bvToast.toast('Processamento realizado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalProcessNotFound');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar';

        if (error.response && error.response.data && error.response.data.errors) {
          message = Object.values(error.response.data.errors)
            .flat()
            .join('\n');
        } else if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },
    resetForm() {
      this.tabIndex = 0;
      this.errors = {};
      this.formPagarme = {
        transactionID: '',
        clientID: '',
        offerID: '',
        leadID: '',
        subscriptionID: '',
      };
      this.formIugu = {
        transactionID: '',
        leadID: '',
        subscriptionID: '',
      };
    },
  },
};
</script>
